import {
  fadeIn,
  slideInFromBottom,
  slideInFromLeft,
  slideInFromRight,
  slideInFromTop,
} from '../animations.css.ts';
import { themeVars } from '../theme/vars.ts';
import { borderRadius, space } from '../tokens.ts';
import { typography } from '../typography.ts';
import { style, styleVariants } from '../layer.css';

export const tooltipContent = style([
  {
    borderRadius: borderRadius.r8,
    padding: space.s16,
    minWidth: 0,
    maxWidth: 320,
    width: 'fit-content',

    animationDuration: '150ms',
    animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
    animationFillMode: 'forwards',
    willChange: 'transform, opacity',

    filter: 'drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.2))',

    selectors: {
      '&[data-state="delayed-open"][data-side="top"]': {
        animationName: `${slideInFromBottom}, ${fadeIn}`,
      },
      '&[data-state="delayed-open"][data-side="right"]': {
        animationName: `${slideInFromLeft}, ${fadeIn}`,
      },
      '&[data-state="delayed-open"][data-side="bottom"]': {
        animationName: `${slideInFromTop}, ${fadeIn}`,
      },
      '&[data-state="delayed-open"][data-side="left"]': {
        animationName: `${slideInFromRight}, ${fadeIn}`,
      },
    },
  },
]);

export const tooltipVariant = styleVariants({
  default: {
    color: themeVars.tooltip.foreground,
    backgroundColor: themeVars.tooltip.background,
  },
  prominent: {
    color: themeVars.tooltip.prominent.foreground,
    backgroundColor: themeVars.tooltip.prominent.background,
  },
});

export const tooltipSize = styleVariants({
  medium: {},
  small: {
    padding: space.s8,
    borderRadius: borderRadius.r4,
  },
});

export const tooltipTitle = style(typography['titleSm']);

export const tooltipDescription = style(typography['bodyMd']);
export const tooltipTextContent = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,
});

export const tooltipActionsRow = style({
  display: 'flex',
  gap: space.s8,
  marginTop: space.s8,
  alignItems: 'center',
  justifyContent: 'center',
});

export const tooltipArrow = style({
  color: themeVars.tooltip.background,
  selectors: {
    [`${tooltipVariant.prominent} &`]: {
      color: themeVars.tooltip.prominent.background,
    },
  },
});
